<template>
  <div id="pass24">
    <v-card class="ep-rechner-box">
      <v-col cols="12" class="p-0">
        <div class="v-card__title p-0">
          <h2 class="v-card--head--title">
            {{ alreadyAssignedTile10 }}
          </h2>
        </div>
      </v-col>

      <v-card-text>
        <v-row
          v-if="
            selectedCase.valN != 3 &&
            selectedCase.valN != 5 &&
            selectedCase.valN != 7
          "
        >
          <v-col cols="12">
            <div class="v-card--msg">
              <h2 class="ep-rechner-h2">
                {{ alreadyAssignedTile11 }}
              </h2>
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <p
              v-html="
                formatDBText(selectedLang.AlreadyAssignedTile12, {
                  'this.flN': flN,
                })
              "
            ></p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
              attach
              v-model="selectMi"
              :items="itemsJN"
              :disabled="pass24"
              item-text="state"
              return-object
              :label="selectedLang.AlreadyAssignedTile13"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <p v-html="selectDiText"></p>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              attach
              v-model="selectDi"
              :items="itemsJN"
              :disabled="pass24"
              return-object
              item-text="state"
              :label="selectedLang.AlreadyAssignedTile15"
            ></v-select>
          </v-col>
        </v-row>

        <v-row v-if="showWarning">
          <v-col cols="12">
            <div class="text-center mb-4 infoHover">
              <v-btn color="warning" outlined @click="alert = !alert">
                {{ selectedLang.AlreadyAssignedTile16 }}
              </v-btn>
            </div>
            <v-alert
              :value="alert"
              border="top"
              color="warning"
              colored-border
              transition="scale-transition"
              class="text-center"
              >{{ alreadyAssignedTile17 }}<br /><b>{{
                alreadyAssignedTile18
              }}</b>
              {{ selectedLang.AlreadyAssignedTile19 }}<br /><b>{{
                selectedLang.AlreadyAssignedTile20
              }}</b>
              {{ selectedLang.AlreadyAssignedTile21 }}</v-alert
            >
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-row v-if="selectedDiv == '24'">
          <v-col cols="12">
            <v-btn
              id="confirm-tarif-refund"
              block
              :disabled="selectMi == '' || selectDi == ''"
              class="btn-ep-next-step"
              @click="check24"
              >{{ selectedLang.AlreadyAssignedTile22 }}</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv != '24' && !noChange">
          <v-col cols="12">
            <v-btn
              id="goto--tarif-refund"
              block
              :disabled="selectMi == '' || selectDi == ''"
              class="btn-ep-back-to"
              @click="backToSpecificTile('24')"
              >{{ selectedLang.AlreadyAssignedTile23 }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "AlreadyAssignedTile",
  data: function () {
    return {
      selectMi: this.$store.state.itemsJN[1],
      selectDi: "",
      selectDiText: "",
      alert: false,
      alreadyAssignedTile10: "",
      alreadyAssignedTile11: "",
      alreadyAssignedTile17: "",
      alreadyAssignedTile18: "",
    };
  },
  computed: {
    ...mapState([
      "itemsJN",
      "kiofCla",
      "pass24",
      "selectedDiv",
      "noChange",
      "selectedLang",
      "flN",
      "flD",
      "showWarning",
      "selectedCase",
      "wAdditional",
      "dataFS",
      "dataTrain",
    ]),
  },
  mounted: function () {
    this.alreadyAssignedTile10 = this.selectedLang.AlreadyAssignedTile10;
    this.alreadyAssignedTile11 = this.formatDBText(
      this.selectedLang.AlreadyAssignedTile11,
      {
        "this.flN": this.flN,
      }
    );
    this.alreadyAssignedTile17 = this.selectedLang.AlreadyAssignedTile17;
    this.alreadyAssignedTile18 = this.selectedLang.AlreadyAssignedTile18;
    if (this.kiofCla == "TRF") {
      this.selectDiText = this.formatDBText(
        this.selectedLang.AlreadyAssignedTile14a,
        { "this.flN": this.flN }
      );
    } else if (this.kiofCla == "TRFDB") {
      this.alreadyAssignedTile10 = this.selectedLang.AlreadyAssignedTile10DB;
      this.alreadyAssignedTile11 = this.formatDBText(
        this.selectedLang.AlreadyAssignedTile11DB,
        {
          bookingCode: this.dataTrain.bookingCode,
        }
      );
      this.selectDiText = this.formatDBText(
        this.selectedLang.AlreadyAssignedTile14DB,
        { bookingCode: this.dataTrain.bookingCode }
      );
      this.alreadyAssignedTile17 = this.selectedLang.AlreadyAssignedTile17DB;
      this.alreadyAssignedTile18 = this.selectedLang.AlreadyAssignedTile18DB;
    } else {
      this.selectDiText = this.formatDBText(
        this.selectedLang.AlreadyAssignedTile14,
        { "this.flN": this.flN }
      );
      this.getAirportSituation(
        "sitSA",
        this.dataFS.airports.airportSC,
        this.flD
      );
      this.getAirportSituation(
        "sitTA",
        this.dataFS.airports.airportTC,
        this.flD
      );
    }
  },
  methods: {
    ...mapActions([
      "backToSpecificTile",
      "goToStep",
      "setSelectedDiv",
      "setVar",
    ]),
    check24() {
      if (
        (this.selectMi.val == "n" &&
          this.selectDi.val == "n" &&
          this.kiofCla != "TRF") ||
        (this.kiofCla == "TRF" && this.selectDi.val == "y")
      ) {
        // if (this.kiofCla == "NB") {
        //   if (this.wAdditional) {
        //     this.setSelectedDiv("31");
        //   } else {
        //     this.setSelectedDiv("35");
        //   }
        // } else if (this.kiofCla == "C") {
        //   this.setSelectedDiv("33");
        // } else if (this.kiofCla == "L") {
        //   this.setSelectedDiv("34");
        // } else if (this.kiofCla == "TRF" || this.kiofCla == "TRFDB") {
        //   this.setSelectedDiv("37");
        // }
        this.setSelectedDiv("50");
        this.setVar({ pos: "pass24", val: true });
      } else {
        if (this.selectMi.val == "y") {
          this.$store.state.rejectionMessage = this.formatDBText(
            this.$store.state.selectedLang.AlreadyAssignedTile5,
            { "this.flN": this.flN }
          );
        } else if (this.selectDi.val == "y") {
          this.$store.state.rejectionMessage = this.formatDBText(
            this.$store.state.selectedLang.AlreadyAssignedTile7,
            { "this.flN": this.flN }
          );
        }
        if (this.kiofCla == "TRFDB") {
          this.$store.state.rejectionMessage = this.formatDBText(
            this.$store.state.selectedLang.AlreadyAssignedTile7DB,
            { bookingCode: this.dataTrain.bookingCode }
          );
        }
        this.setSelectedDiv("32");
      }
      this.goToStep({ vm: this, val: this.selectedDiv });
      this.$gtag.event("6b. Noch keine Entschaedigung erhalten.", {
        event_category: "Rechner",
        event_label: "6b. Noch keine Entschaedigung erhalten.",
      });
      this.setVar({ pos: "selectMi", val: this.selectMi.state });
      this.setVar({ pos: "selectDi", val: this.selectDi.state });
    },
    getAirportSituation(depVal, airportIATA, flD) {
      axios
        .post(
          "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getAirportSitaution.php",
          {
            airportIATA: airportIATA,
            flD: flD,
          }
        )
        .then((response) => {
          this.$store.state.dataEP[depVal] = response.data.body;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally();
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
  },
};
</script>
